// extracted by mini-css-extract-plugin
module.exports = {"layout":"A4_2_Labels_210mm_148mm_2_labels_per_pallet_layout__2DoHA"};